import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=20fe5789&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=20fe5789&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe5789",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fe5789')) {
      api.createRecord('20fe5789', component.options)
    } else {
      api.reload('20fe5789', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=20fe5789&scoped=true", function () {
      api.rerender('20fe5789', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/folder/Create.vue"
export default component.exports